import { render, staticRenderFns } from "./SanteActifs.vue?vue&type=template&id=2ea9fd66&scoped=true&"
import script from "./SanteActifs.vue?vue&type=script&lang=js&"
export * from "./SanteActifs.vue?vue&type=script&lang=js&"
import style1 from "./SanteActifs.vue?vue&type=style&index=1&id=2ea9fd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9fd66",
  null
  
)

export default component.exports